module.exports = __webpack_public_path__ + "img/jwgl-jcsj-cggl.a0106e83.png";